import {BASE_SINGLE_ARG_NUMERIC_FUNCTION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_SINGLE_ARG_NUMERIC_FUNCTION,
  name: 'LOG',
  description: 'Base 10 log of each number in a column or of a single number.',
  shortDescription: 'Logarithm, base 10',
} satisfies AnalysisFunction;
